import PageLayout from "../../components/common/page-layout";
import Docs from "../../components/doc-scanning/schema-editing/docs";
import DocScanningMatchingProgress from "../../components/doc-scanning/schema-testing/job-progress/doc-scanning-job-progress";
import { RequireAuth } from "../../hooks/use-auth";

/**
 * The legacy schema-matching schema editor.
 *
 * Renders full-bleed because the editor is a document canvas plus a sidebar.
 * The bulk-match dock is mounted here as well as on the schema list: its state
 * lives in a module-level store, so a match kicked off from the list stays
 * visible after following a schema through to the editor.
 */
const SchemaEditorPage = () => {
  return (
    <RequireAuth>
      <PageLayout
        disableGutters
        maxWidth={false}
        subtitle="Legacy schema-matching pipeline"
        title="Schema editor"
      >
        <Docs />
        <DocScanningMatchingProgress />
      </PageLayout>
    </RequireAuth>
  );
};

export default SchemaEditorPage;
